import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Raven from 'raven-js';
import flow from 'lodash/flow';

import { Logger } from '../../utils/logger';
import { smoothScrollTo } from '../../utils/smoothScroll';
import { isStringEqual } from '../../utils';

import { getNearMeLink, getLocationLinks } from './utils/children';
import { withSearchInfo } from './provider';

import { CategoryLayout } from './layout';

class CategoryPage extends Component {
  constructor(props) {
    super(props);

    this.state = { nearMeLink: [] };
  }

  componentDidMount() {
    this.fetchNearMe();
  }

  async componentDidUpdate(prevProps) {
    if (!isStringEqual(this.props.query, prevProps.query)) {
      this.scrollViewToTop();
      this.fetchNearMe();
    }

    if (this.props.dataLoading !== prevProps.dataLoading) {
      this.scrollViewToTop();
    }
  }

  scrollViewToTop = () => {
    smoothScrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  // fetches near me tile and appends to beginning of location links
  async fetchNearMe() {
    const { categoryData, searchParams } = this.props;
    const { path } = categoryData;

    try {
      const _getNearMeLink = await getNearMeLink(path, searchParams);
      this.setState({ nearMeLink: [_getNearMeLink] });
    } catch (error) {
      Logger.log(error);
      Raven.captureException(error);
    }
  }

  render = () => {
    const {
      query,
      trackingSource,
      categoryData,
      currentPage,
      resultsPerPage,
      onDescriptionExpand,
      searchParams,
      dataLoading,
    } = this.props;

    const { locationChildren } = categoryData;

    const locationLinks = getLocationLinks(locationChildren, searchParams);
    const locationLinksWithNearMe = this.state.nearMeLink.concat(locationLinks);

    const BrowseLayoutProps = {
      dataLoading,
      query,
      categoryData,
      searchParams,
      onDescriptionExpand, // tracking click
      locationLinks,
      locationLinksWithNearMe,
      trackingSource,
      scrollViewToTop: this.scrollViewToTop,
      currentPage,
      resultsPerPage,
    };

    return (
      <>
        {/* // @dion: Add logic for rendering Find mode here */}
        <CategoryLayout {...BrowseLayoutProps} />
      </>
    );
  };
}

CategoryPage.propTypes = {
  query: PropTypes.shape(),
  events: PropTypes.arrayOf(PropTypes.shape()),
  headerText: PropTypes.string,
  trackingSource: PropTypes.string,
  currentPage: PropTypes.number,
  totalResults: PropTypes.number,
  resultsPerPage: PropTypes.number,
};

CategoryPage.defaultProps = {
  query: undefined,
  events: [],
  currentPage: 1,
  totalResults: 0,
  resultsPerPage: 0,

  headerText: undefined,
  trackingSource: undefined,
};

export default flow(withSearchInfo)(CategoryPage);
